(function () {
    function removeCookie(cname) {
        document.cookie = cname + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
    }

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    const notification = document.querySelector(".notification")
    if (notification) {
        console.log("Notification found")

        const buttons = notification.querySelectorAll("button")
        var md5 = notification.dataset.md5
        var notificationCookie = getCookie("notification")

        if (notificationCookie && notificationCookie == md5) {
            notification.classList.add("collapsed");
        }
        notification.classList.remove("hide")
        if (buttons && buttons.length) {

            for (let btnIdx = 0; btnIdx < buttons.length; btnIdx++) {
                const button = buttons[btnIdx]
                button.addEventListener("click", function (e) {
                    e.preventDefault();
                    const notify = button.closest(".notification")
                    const seconds = document.querySelectorAll(".notification.second")
                    const dismissed = notify.querySelectorAll(".dismissed")
                    if (notify.classList.contains("collapsed")) {
                        notify.classList.remove("collapsed");
                        if (seconds && seconds.length) {
                            seconds.forEach((second) => {
                                second.classList.remove("collapsed")
                            })
                        }
                        if (dismissed && dismissed.length) {
                            dismissed.forEach((diss) => {
                                diss.classList.add("collapsed")
                            })
                        }
                        removeCookie("notification");
                    } else {
                        notify.classList.add("collapsed");
                        if (seconds && seconds.length) {
                            seconds.forEach((second) => {
                                second.classList.add("collapsed")
                            })
                        }
                        if (dismissed && dismissed.length) {
                            dismissed.forEach((diss) => {
                                diss.classList.remove("collapsed")
                            })
                        }
                        setCookie("notification", md5, { expires: 365 });
                        if (button.closest(".homepage").length === 0) {
                            notify.addClass("hide");
                        }
                    }
                })
            }
        }
    }
})();